import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { Icons } from '@/icons/icons'
import CustomDialogActionButtonsComponent from '@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'
import { changeDateFormat } from '@/helpers/dateTime'


export default /*#__PURE__*/_defineComponent({
  __name: 'SageExportPendingDialogComponent',
  props: {
    componentProps: { type: Object, required: true }
  },
  setup(__props: any) {

const props = __props as {
  componentProps: {
    summary?: { total?: { value?: string }; fechaMin?: { value?: string }; fechaMax?: { value?: string } }
    onAccept?: () => void
  }
};

const { t } = useI18n()



const summary = props.componentProps?.summary
const infoIcon = Icons.INFO_FULL

const getRecordsLineParams = () => ({
  count: summary?.total?.value ?? 0,
  fromDate: summary?.fechaMin?.value ? changeDateFormat(summary.fechaMin.value, 'YYYY-MM-DD', 'DD/MM/YYYY') : '',
  toDate: summary?.fechaMax?.value ? changeDateFormat(summary.fechaMax.value, 'YYYY-MM-DD', 'DD/MM/YYYY') : ''
})

const texts = {
  title: t('components.expedient_economic_data.sage_export_pending_title').toString(),
  description: t('components.expedient_economic_data.sage_export_pending_description').toString(),
  recordsIncluded: t('components.expedient_economic_data.sage_export_pending_records_included').toString(),
  recordsLine: t('components.expedient_economic_data.sage_export_pending_records_line', getRecordsLineParams()).toString(),
  primaryButton: t('action_buttons.export_for_sage').toString(),
  secondaryButton: t('action_buttons.cancel').toString()
}

const onAccept = () => {
  store.dispatch(`${ModuleNamespaces.DIALOG}/closeCustomDialog`)
  props.componentProps?.onAccept?.()
}

return { __sfc: true,t, props, summary, infoIcon, getRecordsLineParams, texts, onAccept, CustomDialogActionButtonsComponent }
}

})